export const SORT_DIRECTION = {
  ASC: 'ASC' as const,
  DESC: 'DESC' as const,
};
